import './index_mWeb.css';
import { useEffect, useState } from 'react';
import { getNoPlayingCount, getPlayerName, getTeamPlayerCount } from '../../../utilities/helper';
import useTheme from '../../../utilities/hooks/theme';
import { BsCheckSquareFill } from 'react-icons/bs';
import I18n from '../../../utilities/locale';
import { FaEdit, FaClone, FaClipboardList } from 'react-icons/fa';
import { Card, View, Text } from '../../../component';
import Button from '@mui/material/Button/Button';
import React from 'react';
import Constants from '../../../constants';

interface teamPlayerTypeProps {
  playerRole?: string;
  playerRoleCount?: number;
  theme?: any;
}

const TeamPlayerType = ({ playerRole, playerRoleCount, theme }: teamPlayerTypeProps) => {
  const playerTypeTitle = {
    color: theme.teamBoxPlayerTypeTitle
  };
  const playerTypeValue = {
    color: theme.teamBoxPlayerTypeValue
  };
  return (
    <View className="team-box-content-player-wrapper">
      <Text className="team-box-content-player-type-value" style={playerTypeValue}>
        {playerRoleCount}
      </Text>
      <Text className="team-box-content-player-type" style={playerTypeTitle}>
        {playerRole}
      </Text>
    </View>
  );
};

interface cricketTeamPlayerTypeProps {
  teamCountCricket?: any;
  theme?: any;
}

const CricketTeamPlayerType = ({ teamCountCricket, theme }: cricketTeamPlayerTypeProps) => {
  return (
    <View className="team-box-content-player">
      <TeamPlayerType
        playerRoleCount={teamCountCricket['wkCount']}
        playerRole={'W/K'}
        theme={theme}
      />
      <TeamPlayerType
        playerRoleCount={teamCountCricket['batsmanCount']}
        playerRole={'Bat'}
        theme={theme}
      />
      <TeamPlayerType
        playerRoleCount={teamCountCricket['allRounderCount']}
        playerRole={'A/R'}
        theme={theme}
      />

      <TeamPlayerType
        playerRoleCount={teamCountCricket['bowlerCount']}
        playerRole={'Bowl'}
        theme={theme}
      />
    </View>
  );
};

interface footballTeamPlayerTypeProps {
  teamCountFootball?: any;
  theme?: any;
}

const FootballTeamPlayerType = ({ teamCountFootball, theme }: footballTeamPlayerTypeProps) => {
  return (
    <View className="team-box-content-player">
      <TeamPlayerType
        playerRoleCount={teamCountFootball['gkCount']}
        playerRole={'G/K'}
        theme={theme}
      />
      <TeamPlayerType
        playerRoleCount={teamCountFootball['defenderCount']}
        playerRole={'DEF'}
        theme={theme}
      />
      <TeamPlayerType
        playerRoleCount={teamCountFootball['midfielderCount']}
        playerRole={'MID'}
        theme={theme}
      />

      <TeamPlayerType
        playerRoleCount={teamCountFootball['forwardCount']}
        playerRole={'ST'}
        theme={theme}
      />
    </View>
  );
};
interface Props {
  onPressPreview?: any;
  item: any;
  onPressEdit?: any;
  onPressClone?: any;
  joinedMatch?: boolean;
  selectTeamByUser: any;
  lineupsOut: boolean;
  onPressAlreadyJoin?: any;
  title?: string;
  matchAllPlayersList: any;
  contestTeams: any;
  gameType?: string;
  onPressConvertSubstituteMode: any;
  tabType: any;
}

const TeamBoxMWeb = ({
  onPressPreview,
  item,
  onPressClone,
  onPressEdit,
  joinedMatch,
  selectTeamByUser,
  onPressAlreadyJoin,
  matchAllPlayersList = [],
  lineupsOut = false,
  contestTeams = [],
  gameType = '',
  onPressConvertSubstituteMode,
  tabType
}: Props) => {
  const { FantasyTheme: theme } = useTheme();
  const [alreadyJoined, setAlreadyJoined] = useState(false);
  const [nonPlayingPlayerCount, setNonPlayingPlayerCount] = useState(0);
  const [teamCount, setTeamCount] = useState({
    batsmanCount: 0,
    wkCount: 0,
    allRounderCount: 0,
    bowlerCount: 0,
    raiderCount: 0,
    defenderCount: 0,
    substituteCount: 0,
    gkCount: 0,
    forwardCount: 0,
    midfielderCount: 0
  });

  const {
    id: matchTeamId = '',
    captain = {},
    viceCaptain = {},
    players = [],
    teamNumber = 1,
    isSelected = false
  } = item;
  const { shortName: captainName = '' } = captain;
  const { shortName: viceCaptainName = '' } = viceCaptain;
  useEffect(() => {
    if (lineupsOut) {
      const count = getNoPlayingCount(matchAllPlayersList, players);
      setNonPlayingPlayerCount(count);
    }
    const isAlreadyJoinedIndex = contestTeams.findIndex(function (item: { matchTeamId: any }) {
      return item.matchTeamId === matchTeamId;
    });
    setTeamCount(() => {
      return getTeamPlayerCount(players);
    });

    setAlreadyJoined(isAlreadyJoinedIndex !== -1 ? true : false);
  }, [matchAllPlayersList, players, lineupsOut, contestTeams]);

  const _onPressTeam = (event: any) => {
    event?.stopPropagation();
    if (joinedMatch) {
      if (alreadyJoined) onPressAlreadyJoin();
      else selectTeamByUser(teamNumber - 1);
    }
  };

  const _onPressConvertSubstituteMode = (event: any) => {
    event?.stopPropagation();
    onPressConvertSubstituteMode(item, teamNumber);
  };

  const _onPressEdit = (event: any) => {
    event?.stopPropagation();
    onPressEdit(item, teamNumber);
  };

  const _onPressPreview = (event: any) => {
    event?.stopPropagation();
    onPressPreview(item, teamNumber);
  };
  const _onPressClone = (event: any) => {
    event?.stopPropagation();
    onPressClone(item, teamNumber);
  };

  //code

  const teamNameContainerColor = {
    borderColor: '#98999C'
  };

  const teamNumberColor = {
    color: '#fff'
  };
  const teamBoxNotPlayingCount = {
    color: '#f6324b'
  };
  const bottomButtonTextColor = {
    color: '#fdc400'
  };

  const captainCircleBG = {
    backgroundColor: '#19202a'
  };

  const captainCircleTitle = {
    color: '#ffc400'
  };

  const verticalBorder = {
    backgroundColor: '#485465'
  };

  const iconDimension = '18px';
  return (
    <Card onPress={_onPressTeam} className="team-box-container_mWeb">
      <View className="team-box-name-container_mWeb">
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center'
          }}>
          {joinedMatch && (
            <View onPress={_onPressTeam}>
              {isSelected ? (
                <View onPress={_onPressTeam}>
                  <BsCheckSquareFill size={'20px'} fill={theme.teamBoxCheckBackground} />
                </View>
              ) : (
                <View
                  onPress={_onPressTeam}
                  className="team-box-check-box-wrapper_mWeb"
                  style={{
                    backgroundColor: alreadyJoined ? theme.teamBoxCheckedBackground : 'transparent',
                    borderWidth: '2px',
                    borderColor: alreadyJoined
                      ? theme.teamBoxCheckedBackground
                      : theme.teamBoxCheckBackground
                  }}
                />
              )}
            </View>
          )}
          <View onPress={_onPressTeam}>
            <Text className="team-box-number_mWeb">{`Team ${teamNumber}`}</Text>
          </View>
        </View>
        {nonPlayingPlayerCount > 0 && (
          <View>
            <Text style={teamBoxNotPlayingCount} className={'team-box-not-playing_mWeb'}>
              {`* ${nonPlayingPlayerCount} ${I18n.t('playerAreNotPlayingMsg')}`}
            </Text>
          </View>
        )}
        {gameType === 'SUBSTITUTION' && (
          <Button
            style={{
              backgroundColor: theme.teamBoxSubstituteBtnBG,
              borderRadius: '5px'
            }}
            className={'team-box-add-substitute-button_mWeb'}
            onClick={_onPressConvertSubstituteMode}>
            {teamCount.substituteCount >= 3 ? 'Edit Substitutes' : 'Add Substitutes'}
          </Button>
        )}
      </View>
      {gameType === 'SUBSTITUTION' && teamCount['substituteCount'] > 0 && (
        <View style={teamNameContainerColor} className={'team-box-substitute-count-wrapper_mWeb'}>
          <Text style={teamNumberColor} className={'team-box-substitute-count_mWeb'}>{`* ${
            teamCount['substituteCount']
          } ${I18n.t('subsAdded')}`}</Text>
        </View>
      )}
      <View className="team-box-content-container_mWeb">
        <View className="team-box-content-wrapper_mWeb">
          <View className="team-box-cap-content-wrapper_mWeb">
            <Text className="team-box-captain-name-title_mWeb">{getPlayerName(captainName)}</Text>
            <View className="team-box-captain-vice-captain-circle_mWeb" style={captainCircleBG}>
              <Text className="team-box-captain-vice-captain-text_mWeb" style={captainCircleTitle}>
                {'C'}
              </Text>
            </View>
          </View>
          <View style={{ marginTop: '5px' }} />
          <View className="team-box-cap-content-wrapper_mWeb">
            <Text className="team-box-captain-name-title_mWeb">
              {getPlayerName(viceCaptainName)}
            </Text>
            <View className="team-box-captain-vice-captain-circle_mWeb" style={captainCircleBG}>
              <Text className="team-box-captain-vice-captain-text_mWeb" style={captainCircleTitle}>
                {'VC'}
              </Text>
            </View>
          </View>
        </View>
        <View className="team-box-vertical-border_mWeb" style={verticalBorder} />
        <View className="team-box-content_mWeb">
          {gameType === Constants.GameType.FANTASY_CRICKET && (
            <CricketTeamPlayerType teamCountCricket={teamCount} theme={theme} />
          )}
          {gameType === Constants.GameType.FANTASY_FOOTBALL && (
            <FootballTeamPlayerType teamCountFootball={teamCount} theme={theme} />
          )}
        </View>
      </View>
      {tabType === 'FIXTURE' && (
        <View className="team-box-bottom-button-wrapper_mWeb">
          <View onPress={_onPressEdit} className={'team-box-edit-clone-button_mWeb'}>
            <FaEdit fill={theme.teamBoxBottomIcon} size={iconDimension} />
            <Text className="team-box-bottom-btn-text_mWeb" style={bottomButtonTextColor}>
              {'Edit Team'}
            </Text>
          </View>

          <View onPress={_onPressPreview} className={'team-box-edit-clone-button_mWeb'}>
            <FaClipboardList fill={theme.teamBoxBottomIcon} size={iconDimension} />

            <Text className="team-box-bottom-btn-text_mWeb" style={bottomButtonTextColor}>
              {I18n.t('Preview')}
            </Text>
          </View>
          <View onPress={_onPressClone} className={'team-box-edit-clone-button_mWeb'}>
            <FaClone fill={theme.teamBoxBottomIcon} size={iconDimension} />
            <Text className="team-box-bottom-btn-text_mWeb" style={bottomButtonTextColor}>
              {'Clone Team'}
            </Text>
          </View>
        </View>
      )}
    </Card>
  );
};
TeamBoxMWeb.defaultProps = {
  onPressConvertSubstituteMode: () => {},
  tabType: ''
};
export default React.memo(TeamBoxMWeb);
